import { canGoBack } from '@theme/utilities';

/**
 * Wraps a "back" link: goes back in history when the visitor came from this shop,
 * otherwise follows the link's href.
 */
class BackLink extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('a[href]')) return;
    if (!canGoBack()) return;
    event.preventDefault();
    history.back();
  };
}

if (!customElements.get('back-link')) {
  customElements.define('back-link', BackLink);
}
